// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3H8WE","colCheckbox":"styles_colCheckbox__byTKj"};